export default __webpack_public_path__ + "de1d4cb8b682c9ae2270b1e24d60d004.gif";